<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
                class="py-0"
              >
                <v-autocomplete
                  v-model="company"
                  v-validate="'required'"
                  :items="companies"
                  :error-messages="errors.collect('company')"
                  data-vv-name="company"     
                  label="Company"
                  item-text="name"
                  item-value="id"
                  return-object
                />
              </v-col>
              <v-col
                cols="4"
                class="py-0"
              >
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="formatSalaryMonth"
                      v-validate="'required'"
                      :error-messages="errors.collect('formatSalaryMonth')"
                      data-vv-name="formatSalaryMonth"
                      data-vv-as="salary month"
                      label="Salary Month"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="salaryMonth"
                    type="month"
                    scrollable
                    @click:month="menu = false"
                  />
                </v-menu>
              </v-col>
              <v-col
                cols="4"
                class="ma-auto"
              >
                <v-btn
                  color="success"
                  @click="retrieve"
                >
                  Retrieve Batch
                </v-btn>
                <v-btn
                  color="primary"
                  class="mr-2"
                  @click="beforeGenerate()"
                >
                  Generate New Batch
                </v-btn>

                <payroll-preparation-dialog-delete-batch
                  v-if="(employees.length>0) && (batchData && batchData.status.toUpperCase()!=='COMPLETED')" 
                  :batch-id="batch"
                  @deleted="employees=[]"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <div
            v-if="employees && employees.length > 0"
            class=" summary-table-margin elevation-6"
          >
            <v-row no-gutters>
              <v-col class="text-center pt-2">
                <span class="font-weight-bold summary-header-font-size"><u>Total Monthly Summary</u></span>
              </v-col>
            </v-row>
            <v-row
              no-gutters
            >
              <v-col cols="2" />
              <v-col
                cols="2"
                class="text-right"
              >
                <span class="font-weight-bold">Net Salary (RM)</span>
              </v-col>
              <v-col
                cols="1.5"
                class="text-right"
              >
                <span class="font-weight-bold">PCB (RM)</span>
              </v-col>
              <v-col
                cols="1.5"
                class="text-right"
              >
                <span class="font-weight-bold">EPF (RM)</span>
              </v-col>
              <v-col
                cols="1.5"
                class="text-right"
              >
                <span class="font-weight-bold">SOCSO (RM)</span>
              </v-col>
              <v-col
                cols="1.5"
                class="text-right"
              >
                <span class="font-weight-bold">EIS (RM)</span>
              </v-col>
              <v-col
                cols="2"
                class="text-right pr-5"
              >
                <span class="font-weight-bold">Total (RM)</span>
              </v-col>
            </v-row>
            <v-row
              no-gutters
            >
              <v-col
                cols="2"
                class="pl-5"
              >
                <span class="font-weight-bold">Employee</span>
              </v-col>
              <v-col
                cols="2"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetSalary(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetPcb(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetEmployeeEpf(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetEmployeeSocso(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetEmployeeEis(employees)) }}
              </v-col>
              <v-col
                cols="2"
                class="text-right pr-5"
              >
                {{ currencyFormatting(grandTotalGrossSalary(employees)) }}
              </v-col>
            </v-row>
            <v-row
              no-gutters
            >
              <v-col
                cols="2"
                class="pl-5"
              >
                <span class="font-weight-bold">Employer</span>
              </v-col>
              <v-col cols="2" />
              <v-col
                cols="1.5"
                class="text-right pr-3"
              />
              <v-col
                cols="1.5"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetEmployerEpf(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetEmployerSocso(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetEmployerEis(employees)) }}
              </v-col>
              <v-col
                cols="2"
                class="text-right pr-5"
              >
                {{ currencyFormatting(parseInt(grandTotalNetEmployerEpf(employees) + grandTotalNetEmployerSocso(employees)) + grandTotalNetEmployerEis(employees)) }}
              </v-col>
            </v-row>
            
            <v-divider />
            <v-row
              no-gutters
              style="border-top:1px solid black"
            >
              <v-col
                cols="2"
                class="pl-5 pb-2"
              >
                <span
                  class="font-weight-bold"
                >Total</span>
              </v-col>
              <v-col
                cols="2"
                class="font-weight-medium text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetSalary(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="font-weight-medium text-right pr-3"
              >
                {{ currencyFormatting(grandTotalNetPcb(employees)) }}
              </v-col>
              <v-col
                cols="1.5"
                class="font-weight-medium text-right pr-3"
              >
                {{ currencyFormatting(parseInt(grandTotalNetEmployerEpf(employees) + grandTotalNetEmployeeEpf(employees))) }}
              </v-col>
              <v-col
                cols="1.5"
                class="font-weight-medium text-right pr-3"
              >
                {{ currencyFormatting(parseInt(grandTotalNetEmployerSocso(employees) + grandTotalNetEmployeeSocso(employees))) }}
              </v-col>
              <v-col
                cols="1.5"
                class="font-weight-medium text-right pr-3"
              >
                {{ currencyFormatting(parseInt(grandTotalNetEmployerEis(employees) + grandTotalNetEmployeeEis(employees))) }}
              </v-col>
              <v-col
                cols="2"
                class="font-weight-medium text-right pr-5"
              >
                {{ 
                  currencyFormatting(parseInt(
                    grandTotalNetSalary(employees) 
                      + grandTotalNetPcb(employees) 
                      + grandTotalNetEmployerEpf(employees) + grandTotalNetEmployeeEpf(employees)
                      + grandTotalNetEmployerSocso(employees) + grandTotalNetEmployeeSocso(employees)
                      + grandTotalNetEmployerEis(employees) + grandTotalNetEmployeeEis(employees)
                  )) 
                }}
              </v-col>
            </v-row>
          </div>

          <v-data-table
            v-model="selected"
            :loading="tableLoading"
            :headers="headers"
            :items="employees"
            show-expand
            :show-select="disableShowSelect"
            class="mb-3"
            item-value="id" 
            single-expand
          >
            <template v-slot:item="props">
              <tr>
                <td
                  v-if="disableShowSelect"
                  :class="props.isExpanded? 'remove-bottom-border selectedRow':'border-bottom'"
                >
                  <v-simple-checkbox
                    :class="props.isSelected? 'remove-bottom-border selectedRow':'border-bottom'"
                    :value="props.isSelected"
                    @input="props.select($event)"
                  />
                </td> 

                <td :class="props.isExpanded? 'remove-bottom-border selectedRow':'border-bottom'"> 
                  <span :class="props.isExpanded? 'font-weight-bold':''">{{ props.item.company_employee.employee.person.name }}</span>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border text-right selectedRow':'border-bottom text-right'"> 
                  <span :class="props.isExpanded? 'font-weight-bold':''">{{ currencyFormatting(props.item.current_net_salary) }}</span>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border text-right selectedRow':'border-bottom text-right'"> 
                  <span :class="props.isExpanded? 'font-weight-bold':''">{{ currencyFormatting(props.item.current_pcb_paid) }}</span>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border align-center selectedRow':'border-bottom align-center'">
                  <span :class="props.isExpanded? 'font-weight-bold':''">{{ props.item.employee_working_days }} / {{ props.item.current_month_working_days }}</span>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border align-center selectedRow':'border-bottom align-center'">
                  <span
                    :class="{
                      'warning--text':props.item.status ==='Pending' && !props.isExpanded,
                      'info--text':props.item.status ==='Confirmed' && !props.isExpanded,
                      'green--text':props.item.status ==='Completed' && !props.isExpanded,
                      'font-weight-bold':props.isExpanded
                    }"
                  >
                    {{ props.item.status }}
                  </span>
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border align-center selectedRow':'border-bottom align-center'">
                  <payroll-preparation-dialog-confirmation
                    :salary="props.item"
                    @updated="loadEmployees"
                  />
                </td>

                <td :class="props.isExpanded? 'remove-bottom-border selectedRow':'border-bottom'">
                  <v-btn
                    icon
                    @click="props.expand(!props.isExpanded)"
                  >
                    <v-icon small> 
                      {{ props.isExpanded ? 'fa-chevron-up selectedRow':'fa-chevron-down' }} 
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>

            <template v-slot:expanded-item="{ headers, item }">    
              <td
                :colspan="12"
                class="selectedRow"
              >
                <div class="pb-2 px-2 mb-2">
                  <v-data-table
                    :loading="detailLoading"
                    dense
                    :items="item.salary_details"
                    :headers="detailHeaders"
                    hide-default-footer
                    hide-default-header
                    class="header-border disable-pointer-event "
                  >
                    <template v-slot:header="{}">
                      <thead class="v-data-table-header ">
                        <tr>
                          <th />
                          <th />
                          <th
                            colspan="4"
                            class="text-center customised-header header-border-left header-border-bottom"
                          >
                            Employee (RM)
                          </th>
                          <th
                            colspan="3"
                            class="text-center customised-header header-border-right header-border-left header-border-bottom"
                          >
                            Employer (RM)
                          </th>
                          <th
                            rowspan="2"
                            class="text-center"
                            width="110"
                          >
                            <payroll-preparation-dialog-create
                              v-if="(batchData.status.toUpperCase()!=='COMPLETED')"
                              :payroll="item"
                              @created="loadEmployees"
                            />
                          </th>
                        </tr>

                        <tr>
                          <th class="text-left customised-header">
                            Name
                          </th>

                          <th
                            class="text-center customised-header"
                            width="150"
                          >
                            Amount (RM)
                          </th>

                          <th
                            class="text-center customised-header  header-border-left header-border-bottom"
                            width="120"
                          >
                            PCB
                          </th>

                          <th
                            class="text-center customised-header header-border-left header-border-bottom"
                            width="120"
                          >
                            EPF
                          </th>
                          
                          <th
                            class="text-center customised-header header-border-left header-border-bottom"
                            width="120"
                          >
                            SOCSO
                          </th>

                          <th
                            class="text-center customised-header header-border-left header-border-bottom"
                            width="120"
                          >
                            EIS
                          </th>

                          <th
                            class="text-center customised-header header-border-left header-border-bottom"
                            width="120"
                          >
                            EPF
                          </th>

                          <th
                            class="text-center customised-header header-border-left header-border-bottom"
                            width="120"
                          >
                            SOCSO
                          </th>

                          <th
                            class="text-center customised-header header-border-right header-border-left header-border-bottom"
                            width="120"
                          >
                            EIS
                          </th>
                        </tr>
                      </thead>
                    </template>

                    <template v-slot:item="props">
                      <tr>
                        <td>
                          <span>{{ props.item.allowance_penalty_type.name }}</span>
                        </td>

                        <td class="text-right">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.amount > 0"> 
                            -{{ currencyFormatting(props.item.amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.amount) }}
                          </span>
                        </td>

                        <td class="text-right header-border-left">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.pcb_amount > 0"> 
                            -{{ currencyFormatting(props.item.pcb_amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.pcb_amount) }}
                          </span>
                        </td>

                        <td class="text-right">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employee_epf_amount > 0"> 
                            -{{ currencyFormatting(props.item.employee_epf_amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.employee_epf_amount) }}
                          </span>
                        </td>

                        <td class="text-right">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employee_socso_amount > 0"> 
                            -{{ currencyFormatting(props.item.employee_socso_amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.employee_socso_amount) }}
                          </span>
                        </td>

                        <td class="text-right header-border-right">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employee_eis_amount > 0"> 
                            -{{ currencyFormatting(props.item.employee_eis_amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.employee_eis_amount) }}
                          </span>
                        </td>

                        <td class="text-right">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employer_epf_amount > 0"> 
                            -{{ currencyFormatting(props.item.employer_epf_amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.employer_epf_amount) }}
                          </span>
                        </td>

                        <td class="text-right">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employer_socso_amount > 0"> 
                            -{{ currencyFormatting(props.item.employer_socso_amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.employer_socso_amount) }}
                          </span>
                        </td>

                        <td class="text-right header-border-right">
                          <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employer_eis_amount > 0"> 
                            -{{ currencyFormatting(props.item.employer_eis_amount) }}
                          </span>
                          <span v-else> 
                            {{ currencyFormatting(props.item.employer_eis_amount) }}
                          </span>
                        </td>

                        <td>
                          <payroll-preparation-dialog-edit
                            v-if="(batchData.status.toUpperCase()!=='COMPLETED')"
                            :payroll="props.item"
                            @updated="loadEmployees"
                          />

                          <payroll-preparation-dialog-delete
                            v-if="(batchData.status.toUpperCase()!=='COMPLETED')"
                            :payroll="props.item"
                            @deleted="loadEmployees"
                          />
                        </td>
                      </tr>
                    </template>

                    <template v-slot:body.append>
                      <tr v-if="item && item.salary_details && item.salary_details.length > 0">
                        <td class="footer-td text-right">
                          <span class="font-weight-medium">Total: </span>
                        </td>

                        <td class="text-right">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_gross_salary) }}</span>
                        </td>

                        <td class="text-right header-border-left">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_pcb_paid) }}</span>
                        </td>

                        <td class="text-right">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_epf_employee_contributed) }}</span>
                        </td>

                        <td class="text-right">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_socso_employee_contributed) }}</span>
                        </td>

                        <td class="text-right header-border-right">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_eis_employee_contributed) }}</span>
                        </td>

                        <td class="text-right">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_epf_employer_contributed) }}</span>
                        </td>

                        <td class="text-right">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_socso_employer_contributed) }}</span>
                        </td>

                        <td class="text-right header-border-right">
                          <span class="font-weight-medium"> {{ currencyFormatting(item.current_eis_employer_contributed) }}</span>
                        </td>

                        <td>
                          <span />
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
              </td>
            </template>
          </v-data-table>

          <v-card-actions>
            <v-spacer />
            <payroll-preparation-download-preview
              v-if="batchData"
              :batch-id="batch"
              :status="batchData.status"
              :company="company.name"
              :salarymonth="formatSalaryMonth"
              :salarydate="salaryMonth ? $moment(salaryMonth + '-01'):''"
            />
            <v-btn
              v-if="(batchData && batchData.status.toUpperCase()!=='COMPLETED')"
              color="success"
              :disabled="selected.length<=0"
              @click="checkout"
            >
              Checkout
            </v-btn>
         
            <v-btn
              v-else-if="(batchData && batchData.status.toUpperCase()==='COMPLETED')"
              color="primary"
              @click="template = true"
            >
              Export to bank
            </v-btn>
          </v-card-actions>
        </v-card> 
      </v-col>
    </v-row>

    <v-row>
      <v-dialog
        v-model="batchDialog"
        persistent
        max-width="400px"
      > 
        <material-card
          :offset="10"
          :full-width="true"
          color="green"
          title="Company Salary"
          text="Preparing Batch Name"
          class="mb-0"
        >
          <v-container v-if="batchDialog">
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="name"
                  v-validate="'required'"
                  label="Batch Name"
                  data-vv-name="name"
                  data-vv-as="batch name"
                  :error-messages="errors.collect('name')"
                />  
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions>  
            <v-spacer />
            <v-btn
              :disabled="batchProgressing"
              text
              @click="name = null;batchDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              :loading="batchProgressing"
              color="success"          
              @click="generate"
            >
              Create
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <v-dialog
        v-model="existingBatchDialog"
        persistent
        max-width="400px"
      > 
        <material-card
          :offset="10"
          :full-width="true"
          color="warning"
          title="Warning for Create Batch"
          class="mb-0"
        >
          <v-container v-if="existingBatchDialog">
            <v-row no-gutters>
              <v-col
                v-if="pendingBatches && pendingBatches.length>0"
                cols="12"
              >
                There is an existing <span class="font-weight-bold warning--text">pending</span> payroll batch on <span class="font-weight-bold">{{ selectedFormatSalaryMonth(pendingBatches[0].date) }}</span> under <span class="font-weight-bold">{{ pendingBatches[0].company.name }}</span>. Please checkout before create new batch.
              </v-col>
              <v-col
                v-else
                cols="12"
              >
                There is/are existing payroll batch(es) on <span class="font-weight-bold">{{ formatSalaryMonth }}</span> under <span class="font-weight-bold">{{ company.name }}</span>. Please proceed if you wish to create another new batch.
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions v-if="pendingBatches && pendingBatches.length>0">  
            <v-spacer />
            <v-btn
              color="warning"   
              :disabled="existingBatchProgressing"
              @click="existingBatchDialog=false"
            >
              Close
            </v-btn>
          </v-card-actions>
          <v-card-actions v-else>  
            <v-spacer />
            <v-btn
              :disabled="existingBatchProgressing"
              text
              @click="existingBatchDialog=false"
            >
              Cancel
            </v-btn>
            <v-btn
              :loading="existingBatchProgressing"
              color="warning"          
              @click="existingBatchDialog=false, batchDialog=true"
            >
              Proceed
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <v-dialog
        v-model="batchListingDialog"
        persistent
        max-width="400px"
      > 
        <material-card
          :offset="10"
          :full-width="true"
          color="green"
          title="Company Salary Batch"
          text="Select Batch Name"
          class="mb-0"
        >
          <v-container v-if="batchListingDialog">
            <v-row no-gutters>
              <v-col cols="12">
                <v-autocomplete
                  v-model="batch"
                  v-validate="'required'"
                  label="Batch Name"
                  data-vv-name="batch"
                  data-vv-as="batch name"
                  :items="batches"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors.collect('batch')"
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name" />
                      <v-list-item-subtitle
                        :class="{
                          'warning--text':data.item.status.toUpperCase() ==='PENDING',
                          'info--text':data.item.status.toUpperCase() ==='CONFIRMED',
                          'green--text':data.item.status.toUpperCase() ==='COMPLETED'
                        }"
                      >
                        {{ data.item.status }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>Batch Date: {{ $moment(data.item.created_at).format('YYYY-MM-DD') }} </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions>  
            <v-spacer />
            <v-btn
              :disabled="batchListingProgressing"
              text
              @click="batchListingDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              :loading="batchListingProgressing"
              color="success"          
              @click="loadEmployeeSalaries(false,batch)"
            >
              Retrieve
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <v-dialog
        v-model="checkoutDialog"
        persistent
        max-width="400px"
      > 
        <material-card
          :offset="10"
          :full-width="true"
          color="warning"
          title="Warning for Checkout"
          class="mb-0"
        >
          <v-container v-if="checkoutDialog">
            <v-row no-gutters>
              <v-col
                v-if="selected.length < employees.length"
                cols="12"
              >
                You have selected <span class="font-weight-bold error--text">{{ selected.length }} of {{ employees.length }}</span>. For those un-selected payroll will be eliminated from this batch after checkout. Are you sure you want to proceed?
              </v-col>
              <v-col
                v-else
                cols="12"
              >
                Are you sure you want to checkout?
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions>  
            <v-spacer />
            <v-btn
              :disabled="checkoutProgressing"
              text
              @click="checkoutDialog = false"
            >
              No
            </v-btn>
            <v-btn
              :loading="checkoutProgressing"
              color="warning"          
              @click="confirmCheckout"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <v-dialog
        v-model="warningDialog"
        persistent
        max-width="400px"
      > 
        <material-card
          :offset="10"
          :full-width="true"
          color="warning"
          title="Warning for Checkout"
          class="mb-0"
        >
          <v-container v-if="warningDialog">
            <v-row no-gutters>
              <v-col cols="12">
                Selected data contains status with <span class="font-weight-bold warning--text">Pending</span>. Please check and change the status to <span class="font-weight-bold info--text">Confirmed</span> before <span class="font-weight-bold">Checkout</span>.
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions>  
            <v-spacer />
            <v-btn
              :disabled="warningProgressing"
              color="warning"
              @click="warningDialog = false, containsPending = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>

      <v-dialog
        v-model="template"
        persistent
        max-width="800px"
      >
        <material-card
          :offset="10"
          :full-width="true"
          color="success"
          title="Generate Bank Report"
          text="Select Report Template"
          class="mb-0"
        >
          <v-container v-if="template">
            <v-row no-gutters>
              <v-col
                cols="6"
                class="pr-1"
              >
                <v-autocomplete
                  v-model="bankTemplate"
                  v-validate="'required'"
                  :error-messages="errors.collect('bankTemplate')"
                  data-vv-name="bankTemplate"    
                  data-vv-as="bank template"    
                  label="Bank Template"
                  :items="bankTemplates"
                  item-text="name"
                  return-object
                />
              </v-col>
              <v-col
                cols="6"
                class="pl-1"
              >
                <v-autocomplete  
                  v-model="recordType"
                  v-validate="'required'"
                  label="Record Type"
                  :error-messages="errors.collect('recordType')"
                  data-vv-name="recordType"    
                  data-vv-as="record type"    
                  :items="recordTypes"
                  item-text="name"
                  item-value="code"
                />
              </v-col>
            </v-row>

            <div class="text-center">
              <v-progress-circular
                v-if="retrieving"
                color="primary"
                indeterminate
              />
        
              <div
                v-else-if="processedDatas.length>0"
                class="employee-listing px-3"
              >
                <v-row
                  v-for="(processedData,index) in processedDatas"
                  :key="index"
                  no-gutters
                >
                  <v-col
                    cols="4"
                    class="pr-1"
                  >
                    <v-text-field
                      label="Employee Name"
                      :value="processedData.company_employee.employee.person.name"
                      disabled
                    />
                  </v-col>
                  <v-col
                    cols="4"
                    class="pr-1"
                  >
                    <v-text-field
                      label="Employee Bank"
                      :value="processedData.company_employee.employee.bank.name"
                      disabled
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete
                      v-model="processedData.record_type"
                      :items="recordTypes"
                      label="Record Type"
                      item-text="name"
                      item-value="code"
                    />
                  </v-col>
                </v-row>
              </div>

              <div v-else>
                No data available
              </div>
            </div>
          </v-container>

          <v-card-actions>  
            <v-spacer />
            <v-btn
              :disabled="warningProgressing"
              text
              @click="template = false; bankTemplate = null;recordType = null;processedDatas = []"
            >
              Close
            </v-btn>
            <v-btn
              color="success"
              :loading="downloading"
              @click="download"
            >
              Download
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollPreparationDialogCreate: () => import('@/components/payroll/preparation/DialogCreate'),
      PayrollPreparationDialogEdit: () => import('@/components/payroll/preparation/DialogEdit'), 
      PayrollPreparationDialogDelete: () => import('@/components/payroll/preparation/DialogDelete'), 
      PayrollPreparationDialogConfirmation: () => import('@/components/payroll/preparation/DialogConfirmation'),
      PayrollPreparationDialogDeleteBatch: () => import('@/components/payroll/preparation/DialogDeleteBatch'),
      PayrollPreparationDownloadPreview: () => import('@/components/payroll/preparation/DownloadPreview'),
    },
    inject: ['$validator'],
    data () {
      return {
        template: false,
        company: null,
        companies: [],
        menu: false,
        salaryMonth: null,
        selected: [],
        bankTemplates: [],
        bankTemplate: null,
        recordType: null,
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'company_employee.employee.person.name',
          },
          {
            text: 'Salary (RM)',
            align: 'right',
            value: 'current_net_salary',
          },
          {
            text: 'PCB (RM)',
            align: 'right',
            value: 'current_pcb_paid',
          },
          {
            text: 'No. of Working Days',
            align: 'center',
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
          },
          {
            text: 'Is Checked?',
            align: 'center',
            value: 'action',
          },
          {
            text: '',
            value: 'data-table-expand', 
          },
        ],
        detailHeaders: [
          {
            text: 'Name',
            align: 'left',
            value: 'allowance_penalty_type.name',
            sortable: false,
          }, 
          {
            text: 'Amount(RM)',
            align: 'right',
            value: 'amount',
            sortable: false,
          }, 
          {
            text: 'PCB(RM)',
            align: 'right',
            value: 'pcb_amount',
            sortable: false,
          }, 
          {
            text: 'EE Epf(RM)',
            align: 'right',
            value: 'employee_epf_amount',
            sortable: false,
          }, 
          {
            text: 'EE Socso(RM)',
            align: 'right',
            value: 'employee_socso_amount',
            sortable: false,
          }, 
          {
            text: 'EE EIS(RM)',
            align: 'right',
            value: 'employee_eis_amount',
            sortable: false,
          }, 
          {
            text: 'ER Epf(RM)',
            align: 'right',
            value: 'employer_epf_amount',
            sortable: false,
          }, 
          {
            text: 'ER Socso(RM)',
            align: 'right',
            value: 'employer_socso_amount',
            sortable: false,
          }, 
          {
            text: 'ER EIS(RM)',
            align: 'right',
            value: 'employer_eis_amount',
            sortable: false,
          }, 
          {
            text: '',
            align: 'center',
            value: 'action',
            sortable: false,
          }, 
        ],
        search: '',
        employees: [],
        tableLoading: false,
        generating: false,

        batchDialog: false,
        batchListingDialog: false,
        batchProgressing: false,
        batchListingProgressing: false,
        batch: 0, 
        name: null,
        batches: [],

        existingBatchDialog: false,
        existingBatchProgressing: false,
        pendingBatches: [],

        batchData: null,
        containsPending: false,
        checkoutDialog: false,
        checkoutProgressing: false,
        warningDialog: false,
        warningProgressing: false,
        salaryIds: [],

        processedDatas: [],
        retrieving: false,
        downloading: false,

        detailLoading: false,
      }
    },
    computed: {
      formatSalaryMonth () {
        return this.salaryMonth ? this.$moment(this.salaryMonth + '-01').format('MMM YYYY') : ''
      },

      recordTypes () {
        if (!this.bankTemplate) return []
        return this.bankTemplates.find(template => { return template.id === this.bankTemplate.id }).record_types
      },

      isFilled () {
        if (!this.bankTemplate || !this.recordType) return false

        return true
      },
      
      templateRoute () {
        if (!this.bankTemplate) return
        return this.bankTemplate.name.toLowerCase().replaceAll(' ', '-')
      },

      fileName () {
        if (!this.salaryMonth) return 

        return 'Payroll_' + this.$moment(this.salaryMonth).format('MMMM YYYY').replaceAll(' ', '_')
      },

      disableShowSelect () {
        if (!this.batchData) return

        return this.batchData.status.toUpperCase() !== 'COMPLETED'
      },
    },

    watch: {
      template: function (value) {
        if (value) {
          this.loadBankTemplate()
        }
      }, 
      
      isFilled: function (value) {
        if (value) {
          this.loadPayrollEmployees()
        }
      },
      
    },

    created () {
      this.loadCompanies()
    },
    methods: {
      selectedFormatSalaryMonth (selectedMonth) {
        return selectedMonth ? this.$moment(selectedMonth).format('MMM YYYY') : ''
      },
      grandTotalNetSalary (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_net_salary)
        }
        return sum
      },
      grandTotalGrossSalary (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_gross_salary)
        }
        return sum
      },
      grandTotalNetPcb (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_pcb_paid)
        }
        return sum
      },
      grandTotalNetEmployeeEpf (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_epf_employee_contributed)
        }
        return sum
      },
      grandTotalNetEmployeeSocso (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_socso_employee_contributed)
        }
        return sum
      },
      grandTotalNetEmployeeEis (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_eis_employee_contributed)
        }
        return sum
      },
      grandTotalNetEmployerEpf (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_epf_employer_contributed)
        }
        return sum
      },
      grandTotalNetEmployerSocso (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_socso_employer_contributed)
        }
        return sum
      },
      grandTotalNetEmployerEis (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_eis_employer_contributed)
        }
        return sum
      },
      download () {
        this.downloading = true

        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.$api.payrollExport().download(this.batch, this.templateRoute, { data: this.processedDatas, fileName: this.fileName, company_uid: this.company.id })
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', this.fileName + '.xlsx')
                link.click()

                this.downloading = false
                this.template = false
                this.bankTemplate = null
                this.processedDatas = []
                this.recordType = null
              })
          })
      },

      loadPayrollEmployees () {
        this.retrieving = true

        this.$api.payrollExport().list(this.batch)
          .then(res => {
            let temp = res.data
            temp.map(data => {
              if (data.company_employee.employee.bank.shift_code === this.bankTemplate.shift_code) {
                data.record_type = this.bankTemplate.record_types[0].code
              } else {
                data.record_type = this.recordType
              }
            })
            
            this.processedDatas = temp
            this.retrieving = false
          })
      },

      loadBankTemplate () {
        this.$api.companyBanks().templateList(this.company.id)
          .then(res => {
            this.bankTemplates = res.data
          })
      },
   
      loadEmployees () {
        this.tableLoading = true
        this.detailLoading = true
        Promise.all([
          this.$api.companySalaryBatch().show(this.batch),
          this.$api.payroll().list(this.batch),
        ])
          .then(([selectedBatch, payrollList]) => {
            this.batchData = selectedBatch.data
            this.employees = _.orderBy(payrollList.data, ['company_employee.employee.person.name'], ['asc'])
            this.selected = []
            this.detailLoading = false
            this.tableLoading = false
          })
      },

      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.batchProgressing = true

            this.$api.payroll().create(this.prepareFormData())
              .then(payroll => {
                this.batchProgressing = false

                this.batchDialog = false
                this.name = null
                if (payroll.status === 201) {
                  this.loadEmployeeSalaries(true, payroll.data.data.id) 
                } else if (payroll.status === 200) {
                  this.$snack({ color: 'red', message: 'Invalid salary month' })
                }
              })
          })
      },

      loadEmployeeSalaries (isRetrieve, batchId) {
        this.tableLoading = true

        if (isRetrieve) this.batch = batchId

        Promise.all([
          this.$api.companySalaryBatch().show(batchId),
          this.$api.payroll().list(this.batch),
        ])
          .then(([selectedBatch, payrollList]) => {
            this.batchData = selectedBatch.data
            this.employees = _.orderBy(payrollList.data, ['company_employee.employee.person.name'], ['asc'])
            
            this.tableLoading = false
            this.selected = []
            this.batchListingDialog = false
          })
      },
      
      checkout () {
        this.selected.forEach(item => {
          if (item.status.toUpperCase() === 'PENDING') {
            this.containsPending = true
            return false
          }
          this.salaryIds.push(item.id)
        })
        if (this.containsPending) {
          this.warningDialog = true
        } else {
          this.checkoutDialog = true
        }
      },

      confirmCheckout () {
        this.tableLoading = true
        this.checkoutProgressing = true

        this.$api.payroll().checkout(this.batch, this.salaryIds)
          .then(res => {
            this.loadEmployees()
            this.$emit('updated')
            this.$snack({ message: 'Salary status succesfully updated' })

            this.salaryIds = []
            this.checkoutDialog = false
            this.checkoutProgressing = false
            this.tableLoading = false
          }).catch(() => {
            this.$snack({ 
              color: 'error',
              message: 'Failed to update salary status', 
            })
          })
      },

      beforeGenerate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.existingBatchProgressing = true

            Promise.all([
              this.$api.companySalaryBatch().list({ date: this.salaryMonth, company_uid: this.company.id, status: null }),
              this.$api.companySalaryBatch().list({ date: null, company_uid: this.company.id, status: 'Pending' }),
            ])
              .then(([batches, pendingBatches]) => {
                if (batches.data.length > 0 || pendingBatches.data.length > 0) {
                  this.batches = _.orderBy(batches.data, ['created_at', 'name'], ['desc', 'asc'])
                  this.pendingBatches = _.orderBy(pendingBatches.data, ['created_at', 'name'], ['desc', 'asc'])
                  this.existingBatchDialog = true
                } else {
                  this.existingBatchDialog = false
                  this.batchDialog = true
                }
              })

            this.existingBatchProgressing = false
          })
      },

      retrieve () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.$api.companySalaryBatch().list({ date: this.salaryMonth, company_uid: this.company.id, status: null })
              .then(res => {
                if (res.data.length > 0) {
                  this.batches = _.orderBy(res.data, ['created_at', 'name'], ['desc', 'asc'])
                  this.batchListingDialog = true
                } else {
                  this.$snack({ color: 'red', message: 'No Record Found' })
                }
              })
          })
      },

      prepareFormData () {
        return {
          date: this.salaryMonth, 
          company_uid: this.company.id, 
          name: this.name,
          salaryMonth: this.salaryMonth,
        }
      },

      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },

      loadCompanies () {
        this.$api.companies().list()
          .then(res => {
            this.companies = _.orderBy(res.data, ['name'], ['asc'])     
          })
      },
      
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>

<style scoped>
.remove-bottom-border {
  border-bottom: 0px !important
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}

.align-center {
  text-align:center
}

.selectedRow {
  background-color: rgb(190,216,249)
}

.customised-header{
  font-size:1.0625rem !important
}

.header-border{
  border:1px solid black
}

.header-border-left{
  border-left:1px solid black
}

.header-border-right{
  border-right:1px solid black
}

.header-border-bottom{
  border-bottom:1px solid black !important
}

.disable-pointer-event tr:hover:not(.v-table__expanded__content) {
  background: transparent !important;
}

.employee-listing{
  height:500px;
  overflow-y:scroll;
}

.employee-listing::-webkit-scrollbar {
  width: 3px !important; 
}

/* Track */
.employee-listing::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
.employee-listing::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
.employee-listing::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}

.summary-header-font-size{
  font-size: 24px;
}
.summary-table-margin{
  margin:20px;
  border-radius:10px;
}

</style>
